module.exports = new __parcel__URL__("shop_nfts_button_inactive.f0561222.png").toString();